module.exports = __webpack_public_path__ + "img/crossbow.7d1a4ad7.svg";